module.exports = __webpack_public_path__ + "img/logo_iris.374dba8c.png";